import { useState } from '#imports'
import { computed } from 'vue'

export function useActiveMenu() {
  const activeMenu = useState<string | undefined>(
    'menu-active',
    () => undefined,
  )
  const isMenuActive = computed(() => activeMenu.value !== undefined)

  function setActiveMenu(id: string | undefined): void {
    activeMenu.value = id
  }

  function clearActiveMenu(): void {
    activeMenu.value = undefined
  }

  return {
    activeMenu,
    isMenuActive,
    setActiveMenu,
    clearActiveMenu,
  }
}
